/**
 * App footer. Static credits / copyright line.
 */
import type { ReactElement } from 'react';

/** Minimal footer shown at the bottom of the app shell. */
export default function Footer(): ReactElement {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-gray-200 px-4 py-4 text-center text-xs text-gray-400 sm:px-6">
      © {year} Ads360
    </footer>
  );
}
